import React from 'react';
import PropTypes from 'prop-types';
import Chip from './Chip';

export const ChipsList = ({ items, removeChip, cookiesInfoUrl }) => {
  const renderChips = () => {
    let chips = [];
    items.forEach((item, index) => {
      chips.push(
        <Chip
          cookiesInfoUrl={cookiesInfoUrl}
          key={`${item.category}-${index}`}
          name={item.name}
          removeCloseButton={item.removeCloseButton}
          linksTo={item.linksTo}
          id={item.id}
          removeChip={() => removeChip(item)}
        />
      );
    });
    return chips;
  };
  return <div className="chips-container">{renderChips()}</div>;
};

ChipsList.propTypes = {
  items: PropTypes.array.isRequired,
  removeChip: PropTypes.func
};

export default ChipsList;
